const report_manage = [{
    path: 'report-manage/daily',
    meta: {
      name: "提交日报"
    }
  },
  // {
  //   path: 'report-manage/weekly',
  //   meta: {
  //     name: "提交周报"
  //   }
  // },
  // {
  //   name: 'newWeekly',
  //   path: 'report-manage/newWeekly',
  //   meta: {
  //     name: "提交周报1"
  //   }
  // },
]

export default report_manage



// WEBPACK FOOTER //
// ./src/router/mapping/report-manage.js